import {HttpParameterCodec} from '@angular/common/http'

/**
 * `HttpParameterCodec` que usa `encodeURIComponent` y `decodeURIComponent` para
 * serializar and parsear URL query.
 *
 * Arregla issue de Angular:
 * https://github.com/angular/angular/issues/11058
 */
export class WebHttpUrlEncodingCodec implements HttpParameterCodec {

  encodeKey(k: string): string {
  	return encodeURIComponent(k);
  }

  encodeValue(v: string): string {
  	return encodeURIComponent(v);
  }

  decodeKey(k: string): string {
  	return decodeURIComponent(k);
  }

  decodeValue(v: string) {
  	return decodeURIComponent(v);
  }
}



// WEBPACK FOOTER //
// ./src/helpers.ts